module.exports = __webpack_public_path__ + "static/jason-fried-5e7a34d8453c56e65708f7e369821da2.jpg";